import { CATEGORIES } from '../constants/content';

export default function Categories() {
  return (
    <section className="fm-section fm-section--alt" id="categories">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">Categories</p>
          <h2 className="fm-sec-title">Browse by specialty</h2>
          <p className="fm-sec-lead">
            From illustration to analytics, find the right software for the work
            your team ships every week.
          </p>
        </div>
        <div className="fm-cat-list">
          {CATEGORIES.map((item) => (
            <article key={item.title} className="fm-cat">
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
